import React, { useState, useCallback } from 'react';
import { Button, Label, Input } from 'reactstrap';
import { UPDATE_BOX_ADMIN } from '../../../mutation/mutation';
import { useMutation } from '@apollo/react-hooks';

const AdminWrite = ({ admin, senders, onSelect, onValidate, onAbort }) => (
  <div>
    <Label for="exampleSelect"><b>Select the new admin from the senders</b></Label>
    <Input type="select" name="select" id="exampleSelect" onChange={onSelect} value={admin}>
      { senders.map(item => (
        <option>{item}</option>
      ))
      }
    </Input>
    <br/>
    <Button style={{ marginRight: 10 }} color="danger" onClick={onValidate}>Validate</Button>
    <Button color="secondary" onClick={onAbort}>Cancel</Button>
  </div>
);

const AdminRead = ({ admin, onPress }) => (
  <div>
    <b>Admin:</b> {admin}
    <br/>
    <Button
      type="submit"
      color="primary"
      onClick={onPress}
    >
      Change admin
    </Button>
  </div>
);

const Admin = ({ admin, senders, boxId }) => {
  const [modifying, setModifying] = useState(false);
  const [newAdmin, setNewAdmin] = useState(admin);
  const [initialAdmin, setInitialAdmin] = useState(admin);
  const [savUpdateBoxAdmin] = useMutation(UPDATE_BOX_ADMIN);

  const handleAbortChanges = useCallback(
    async (e) => {
      setNewAdmin(initialAdmin);
      setModifying(false);
    }, [initialAdmin]
  );

  const handleAdminChange = useCallback(
    async () => {
      const confirm = window.confirm('⚠️ Are you sure you want to change the admin of this box ?');
      if (!confirm) {
        return;
      }

      try {
        await savUpdateBoxAdmin({ variables : { boxId, newAdminEmail: newAdmin } });
        setInitialAdmin(newAdmin);
        setModifying(false);
      } catch (e) {
        setNewAdmin(initialAdmin);
        console.log(e);
      }
    }, [boxId, newAdmin]
  );

  return (modifying) ?
    <AdminWrite
      admin={newAdmin}
      senders={senders}
      onSelect={(e) => setNewAdmin(e.target.value)}
      onValidate={handleAdminChange}
      onAbort={handleAbortChanges}
    />
    : <AdminRead admin={newAdmin} onPress={() => {setModifying(true);}}/>;
};

export default Admin;



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/infos/admin.js